/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import { FlexContainer } from "@nordcloud/gnui";
import { StepCounter, StepWrapper } from "./styles";

type Props = PropsWithChildren<{
  counter: number;
}>;

export function StepContainer({ counter, children }: Props) {
  return (
    <FlexContainer alignItems="flex-start">
      <StepCounter>{counter}</StepCounter>
      <StepWrapper>{children}</StepWrapper>
    </FlexContainer>
  );
}
